export default __webpack_public_path__ + "static/media/project.c038f535.svg";